import { TranslateService } from '@ngx-translate/core';

import { isEmpty, isString } from 'lodash-es';
import { SharedLanguageService } from '../services/shared-language.service';

export function optionalTranslate(
    translateService: TranslateService | SharedLanguageService,
    fieldFlatKey: string,
    value: string
): string {
    /* Metadata translation overrides are stored in the 'overrides' block in the language file.
     * They follow the following structure: overrides.<FlatKey of the field>.<value>
     * <value> is the value as provided, with the spaces removed.
     *
     * When performing translate.instant(jsonPath) and the translation is not found, jsonPath is returned.
     * This helper is written to return the original value instead.
     */

    const result: string | null = getTranslation(translateService, fieldFlatKey, value);

    return result ? result : value;
}

export function getTranslation(
    translateService: TranslateService | SharedLanguageService,
    fieldFlatKey: string,
    value: string = ''
): string | null {
    const noSpaces: string = value.replace(/ /g, '').toLowerCase();

    const lookupKey: string = isEmpty(noSpaces) ? `overrides.${fieldFlatKey}` : `overrides.${fieldFlatKey}.${noSpaces}`;
    const translated: string = translateService.instant(lookupKey);

    return translated === lookupKey || !isString(translated) ? null : translated;
}
